/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLabelText: {
  name: 'label-text';
  data: string;
} = {
  name: 'label-text',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.144 5.353a2 2 0 0 1 2.21-2.209l7.408.824a2 2 0 0 1 1.193.573L20 10.586a2 2 0 0 1 0 2.828L13.414 20a2 2 0 0 1-2.828 0l-6.045-6.044a2 2 0 0 1-.573-1.194l-.824-7.41Zm1.988-.221.823 7.41L12 18.585 18.586 12 12.54 5.955l-7.409-.823Zm6.161 3.16a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1-1.414 1.415l-3-3a1 1 0 0 1 0-1.414Zm-1.586 3a1 1 0 0 0-1.414 1.415l1 1a1 1 0 0 0 1.414-1.414l-1-1Z" fill="currentColor"/></svg>`,
};
